<template>
	<div class="clientPage">
		<div v-if="bIsLoading && masClient.length==0">Загружаем данные...</div>
		<div v-if="!bIsLoading && (masClient==undefined || masClient.length==0)">Клиент не найден или у вас нету доступа</div>
		<div v-else>
			<div v-if="bIsEdit && masClient.length>0">
				<div class="clientPage bntGroup">
					<base-button @click="GoToEdit(false)" type="primary" class="no-border" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
				</div>
				<ReCardClientEdit :objClient="masClient[0]" />
			</div>
			<card v-else class="mobilePadding ">
				<div v-if="masClient.length>0" class="my-row">
					<!-- <div class=""></div> -->
					<!-- <div class="col-md-12 col-lg-6"></div> -->
					<!-- <card class="collapseArrow"></card> -->
					<collapse :name="'c-c_'+masClient[0].id" :activeIndex="objTabs.client==true?0:-1" >
						<collapse-item :name="'c_'+masClient[0].id" @activate="onCollapseClient" >
							<div slot="title" class="col-title">
								<h3 class="mr-2">{{'ID '+masClient[0].id}}</h3>
								<!--h3 class="mx-auto">{{[masClient[0].name,masClient[0].surname].join(' ')}}</h3-->
								<h3 class="mx-auto title-client-fio">{{masClient[0].fio}}</h3>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="!this.objTabs.client">открыть</span>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="this.objTabs.client">скрыть</span>

							</div>
							<div class="clientPage bntGroup">
								<base-button v-if="isAdmin || bCanEdit" @click="GoToEdit()" type="primary" class="no-border" simple icon><i class="d-inline-block tim-icons icon-pencil"></i></base-button>
								<div class="btn-history">
									<el-tooltip content="История изменений" placement="bottom">
										<el-button  class="no-border"><base-button @click="GoToHistory()" type="primary" class="no-border" simple icon><i class="d-inline-block tim-ic ic-history "></i></base-button></el-button>
									</el-tooltip>
								</div>
								<div class="btn-chat" v-if="masClient[0].root_id == 0">
									<el-tooltip content="Чаты с клиентом" placement="bottom">
										<el-button @click="GoToChat()" class="no-border"><base-button  type="primary" class="no-border" simple icon><i class="d-inline-block tim-icons icon-chat-33 "></i></base-button></el-button>
									</el-tooltip>
								</div>
							</div>
							<ReCardClient :objClient="masClient[0]" />

							<div class="col-lg-12 col-md-12 px-0">
									<card type="cinc" class="ServiceFilter lightTheme">
										<!-- <h4>Если хотелки расширятся, то ReFormPrinter? И с сохранением настроек в Мой шаблон?</h4> -->
										<!-- <label class="col-form-label pt-0" v-if="masClient[0].SERVICES.length>1">Выберите услугу для фильтрации всех данных в карточке клиента</label> -->
										<div class="form-group mb-0" >
											<div class="col-md-12 col px-0">
												<div class=" d-flex px-0">
													<i class="d-inline-block tim-ic ic-filter mr-2 my-auto text-primary"></i>
													<el-select
														class="select-primary"
														size="large"
														placeholder="Отфильтровать все данные клиента по услуге" 
														clearable
														filterable
														v-model="strChosenService"
														@change="setServiceFiler(strChosenService)"
													>
														<el-option
															v-for="(el_opt, el_index) in ServicesInWorkSelect"
															class="select-primary"
															:value="el_opt.id"
															:label="'ID ' + el_opt.id + ' ' + el_opt.BP_NAME"
															:key="el_index"
														>
														</el-option>
													</el-select>
													<base-button type="danger" class="no-border my-0" simple icon @click="clearService">
														<i class="d-inline-block tim-icons icon-simple-remove"></i>
													</base-button>
													<!-- <div>
														<el-tooltip content="Сохранить текущие настройки как 'Мой шаблон'" placement="top">
															<base-button class="btn btn-icon btn-simple btn-primary my-0" > <i class="tmplt-icon"></i> </base-button> 
														</el-tooltip>
													</div> -->
												</div>
											</div>	
											<!-- <div class="col-md-12 col-lg-3 px-0 mb-2">
												<base-button @click="getServicesForTaskFilter(strChosenService)" type="success" class="my-0" simple>Применить</base-button>
											</div>	 -->
										</div>
									</card>
							</div>
						</collapse-item>
					</collapse>
					
					
					<!-- <div class=""></div> -->
					<!-- <card class="collapseArrow"></card> -->
					<collapse :name="'c-ct_'+masClient[0].id" :activeIndex="objTabs.task==true?0:-1">
						<collapse-item :name="'c-ct_'+masClient[0].id" @activate="onCollapseTask">
							<div slot="title" class="col-title task-pl-3">
								<h3 class="mb-0">ЗАДАЧИ </h3> 
								<h3 v-if="strNumberOfTasks" class="ml-2 mb-0 text-primary" style="font-size: 1.2em;">(всего задач: {{strNumberOfTasks}})</h3>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="!this.objTabs.task">открыть</span>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="this.objTabs.task">скрыть</span>
							</div>
							<!-- allTask
							<template v-if="masClient[0].SERVICES.length>0">
								<template v-for="(service,service_index) in masClient[0].SERVICES">
									<template v-if="service.BP_TASKS.length>0">
										<ReCardTask v-for="(task,task_index) in service.BP_TASKS" 
										:objTask="$GVO.unlinkObject(task)" 
										:objService="$GVO.unlinkObject(service)" 
										:objClient="$GVO.unlinkObject(masClient[0])" 
										:chosenServiceID="strChosenServiceID"
										:key="task_index"
										/>
										
									</template>
								</template>
							</template>							 
							 -->
							 <template v-if="taskList.length>0">
								<template v-for="(task,index) in taskList">
									<ReCardTask  
									v-if="index<showTask"
									:objTask="$GVO.unlinkObject(task.task)" 
									:objService="$GVO.unlinkObject(task.service)" 
									:objClient="$GVO.unlinkObject(masClient[0])" 
									:chosenServiceID="strChosenServiceID"
									:key="index"
									/>
								</template>
								<div class="d-flex justify-content-center"  v-if="taskList.length>showTask">
									<base-button @click="LoadTask()" type="primary" class="mb-2" simple >
									Показать ещё {{ Math.min(taskList.length - showTask, showTaskAppend) }} {{ ((taskList.length - showTask>showTaskAppend)? ' из '+(taskList.length - showTask):'')}}</base-button>
								</div>
							</template>
						</collapse-item>
					</collapse>
					
					

					<!-- <div class=""></div> -->
					<!-- <card class="collapseArrow"></card> -->
					<collapse :name="'c-c_'+masClient[0].id" :activeIndex="objTabs.main==true?0:-1">
						<collapse-item :name="'c-c_'+masClient[0].id" @activate="onCollapseMain">
							<div slot="title" class="col-title">
								<h3>УСЛУГИ</h3>
								<h3 v-if="ServicesInWork.length" class="ml-2 mb-0 text-primary" style="font-size: 1.2em;">(всего услуг: {{ServicesInWork.length}})</h3>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="!this.objTabs.main">открыть</span>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="this.objTabs.main">скрыть</span>
							</div>	
										
							<div class="d-flex">
								<ReCardServiceAdd v-if="masClient[0]" :objClient="masClient[0]" />
							</div>
								

							<template v-if="ServicesInWork.length>0">
								<template v-for="(objService, index) in sortSERVICES(ServicesInWork)">
									<ReCardServiceView v-if="index<servicesToShow" 
									:key="'inwork_'+index" 
									:id="objService.id"
									:objService="objService" 
									:objNoPurposeGrouped="objNoPurpose.group_bp_id[objService.BP_ID]"
									:clientId="clientId"
									:class="[{'hideServices': (( (objService.STATUS != 'В работе' && objService.STATUS != 'Новая услуга' && objService.STATUS != 'На контроле') && ServicesInArchive.length > 0) && ishidden)}]" 
									/>
								</template>
								<div class="d-flex justify-content-center"  v-if="ServicesInWork.length>servicesToShow">
									<base-button @click="LoadService()" type="primary" class="mb-2" simple >
									Показать ещё {{ Math.min(ServicesInWork.length - servicesToShow, servicesToShowAppend) }} {{ ((ServicesInWork.length - servicesToShow>servicesToShowAppend)? ' из '+(ServicesInWork.length - servicesToShow):'')}}</base-button>
								</div>
							</template>
							<template v-if="ServicesInArchive.length>0">
								<ReCardServiceView v-for="(objService, index) in ServicesInArchive" :key="'archive_'+index" :id="objService.id" :objService="objService" :objNoPurposeGrouped="objNoPurpose.group_bp_id[objService.BP_ID]"
								:class="[{'hideServices': (( (objService.STATUS != 'В работе' && objService.STATUS != 'Новая услуга' && objService.STATUS != 'На контроле') && ServicesInArchive.length > 0) && ishidden)}]" 
								/>

								<div class="d-flex justify-content-center" v-if="ServicesInArchive.length > 0" >
									<base-button @click="showServices()" type="primary" class="mb-2" simple >
									{{expandText.text}}</base-button>
								</div>
							</template>


							<!-- <div v-for="(objService, index) in sortSERVICES(masClient[0].SERVICES)" :key="index">
								<ReCardServiceView  
								:id="objService.id" 
								:objService="objService" 
								:objNoPurposeGrouped="objNoPurpose.group_bp_id[objService.BP_ID]"
								:class="[
									{'hideServices': (((objService.STATUS != 'В работе' && objService.STATUS != 'Новая услуга' && objService.STATUS != 'На контроле') && masClient[0].SERVICES.length > 1) && ishidden)},
									{'anchorService': (objService.id == anchorServiceID) && anchorServiceID !='undefined'}]" 
								/>
							</div>
							<div class="d-flex justify-content-center" v-if="(numOfServicesNotInWork !=0 && masClient[0].SERVICES.length != 1) && masClient[0].SERVICES.length > 0">
								<base-button @click="showServices()" type="primary" class="mb-2" simple >{{expandText.text}} {{numOfServicesNotInWork}}</base-button>
							</div>	 -->
							
						</collapse-item>
					</collapse>
					
					
					<!-- <div class=""></div> -->
					<!-- <card class="collapseArrow"></card> -->
					<collapse :name="'c-cl_'+masClient[0].id" :activeIndex="objTabs.lenta==true?0:-1">
						<collapse-item :name="'c-cl_'+masClient[0].id" @activate="onCollapseLenta">
							<div slot="title" class="col-title">
								<h3>ЛЕНТА</h3>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="!this.objTabs.lenta">открыть</span>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="this.objTabs.lenta">скрыть</span>
							</div>
							<ReClientLentaNest :id="masClient[0].id"  :filter_service_id="strChosenService" @anchorservice="receiveEmitAnchor" />
						</collapse-item>
					</collapse>
					
					
				</div>
			</card>
		</div>
	</div>
</template>
<script>
import ReCardClient from 'src/our_components/ReCardClient.vue';
import ReCardClientEdit from 'src/our_components/ReCardClientEdit.vue';
import { Collapse, CollapseItem } from 'src/components';
import { Select, Option } from 'element-ui';
import ReCardServiceAdd from 'src/our_components/ReCardServiceAdd.vue';
import ReCardServiceView from "src/our_components/ReCardServiceView.vue";
import ReCardTask from "src/our_components/ReCardTask.vue";
import ReClientLentaNest from "src/our_components/ReClientLentaNest.vue";
import {eventEmitter} from "src/plugins/globalComponents.js";
import { /*Tooltip,*/ Button } from 'element-ui';

export default {
	name: 'client-page',
	components: {
		ReCardClientEdit,
		ReCardClient,
		Collapse, 
		CollapseItem,		
		ReCardServiceAdd,
		ReCardServiceView,
		ReCardTask,
		ReClientLentaNest,
		// Tooltip,	
		[Button.name]: Button,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			masClient: [],
			bIsLoading: true,
			bIsEdit: false,
			bCanEdit: true,
			objTabs: {client: true,main: true,task:true,lenta:true},
			arrServices: [],
			strNumberOfTasks: '',
			taskList: [],
			ishidden: true, 
			numOfServicesNotInWork: 0,
			expandText: {
				text: "Показать услуги в архиве"
			},
			objNoPurpose:{selectedVal:'',descr:'',options:[], group_bp_id:[]},
			strChosenService:'',
			strChosenServiceID:'',
			ServicesInWork:[],
			ServicesInWorkSelect:[],
			ServicesInArchive: [],
			anchorServiceID: '',
			servicesToShow: 5,
			servicesToShowAppend: 5,
			showTask: 5, // сколько задач покзываем по умолчанию
			showTaskAppend: 10, // сколько загружаем по кнопке
			clientId: '',
		};
	},
	watch: {
		$route(to, from) {
			this.init();
		}
	},
	methods: {
		LoadTask(){
			this.showTask+= this.showTaskAppend;
		},
		LoadService(){
			this.servicesToShow+= this.servicesToShowAppend;
		},
		getServiceFilter(){
			let url = new URL(location);
			this.strChosenService = url.searchParams.get('service');
		},
		setServiceFiler(id){
			let url = new URL(location);
			if(url.searchParams.get('service') != id){
				url.searchParams.set('service',id);
				this.$router.replace({path: url.search});
			}
			this.getClient(id);
		},
		clearService(){
			let url = new URL(location);
			url.searchParams.delete('service');
			this.$router.replace({path: url.search});
			this.strChosenServiceID = '';
			this.strChosenService = '';
			this.getClient()
		},
		getClient(strChosenService){
			this.bIsLoading = true;
			let canEdit = false;
			// console.log('getClient',this.$route.query.phoneint);
			this.strChosenServiceID = strChosenService;
			let phoneint='';
			if(this.$route.query != 'undefined' && this.$route.query.phoneint != 'undefined'){
			    phoneint = this.$route.query.phoneint;
			}
			let cascade_service_id = '';
			// console.log(this.strChosenService);
			if(this.strChosenService && this.strChosenService!=''){
				cascade_service_id = {cascade_service_id:this.strChosenService};
				this.numOfServicesNotInWork = 0;
				this.strNumberOfTasks = '';
			}else {cascade_service_id = {}};
			
			
			if(typeof this.$route.params.client_id != 'undefined'){
				this.clientId = this.$route.params.client_id
				this.masClient=[];
				this.taskList=[];
				// console.log(cascade_service_id);
				this.$GVO.ApiCall('GET',{obj:'client' ,flt:{
					id: this.$route.params.client_id,
					phoneint: phoneint,
					'addVirtWatsapp': 1,
					...cascade_service_id,
					save_service_view:true,
				}})  // cascade_service_id: this.strChosenService
				.then((objApi) => { 
					this.bIsLoading = false;
					// console.log(objApi);
					if(objApi.success === true){
						if(typeof this.$GVO.cats['CONTACTS_TYPES'] == 'undefined'){
							this.$GVO.ApiCall('GET_CONTACTS_TYPES',{obj:"staff"})
								.then((objApiCat) => { 
									//console.log('GET_CONTACTS_TYPES',objApi);
									if(objApiCat.success === true){
										this.$GVO.cats['CONTACTS_TYPES'] = objApiCat.data;
										this.masClient = objApi.data;
										
									}
								}).catch(errorObjApi => {console.error(errorObjApi);});
						}else{
							this.masClient = objApi.data;
							let client = this.masClient[0];
							if(client.root_id==0) canEdit=true;
							// ниже считаем сколько задач в коллапсе ЗАДАЧИ
							// console.log('this.masClient[0].SERVICES.length',this.masClient[0].SERVICES.length);
							if(this.masClient[0].SERVICES.length>0){
								let sum = 0;
								let allTask = [];
								for (let i = 0; i < this.masClient[0].SERVICES.length; i++) {
									let service = this.masClient[0].SERVICES[i];
									if(service.client_id == this.clientId){
										canEdit=true;
									}
									if(service.BP_TASKS.length>0) {
										for (let j = 0; j < service.BP_TASKS.length; j++) {
											allTask.push({
												task: service.BP_TASKS[j],
												service: service,
											})
											sum = sum + 1;
											// console.log(this.masClient[0].SERVICES[i].BP_TASKS[j].id);
										}
									}
									if(service.STATUS != 'В работе' 
										&& service.STATUS != 'Новая услуга' 
										&& service.STATUS != 'На контроле'){
										//console.log('In works');
										this.numOfServicesNotInWork++;
										
									} 
								}
								this.strNumberOfTasks = sum;
								this.taskList = allTask;
								//console.log(sum);
							}
						}
						this.getServicesInWork();
						// this.getServicesForTaskFilter();
						this.bCanEdit = canEdit;
					}
				}).catch(errorObjApi => {console.error(errorObjApi); this.bIsLoading = false;});
			}else{
				if(location.pathname.indexOf('/data/clients/add') != -1){
					this.bIsEdit = true;
				}
				this.bIsLoading = false;
				this.masClient.push({});
			}
		},
		isArchive(Service){
			// Сортировка услуг по признаку архива
			if(!Object.prototype.hasOwnProperty.call(Service,'_archive')){
				Service['_archive'] = (Service.STATUS == 'В работе' || Service.STATUS == 'Новая услуга' || Service.STATUS == 'На контроле') ? 0 : 1
			}
			return Service['_archive']
		},
		sortSERVICES(arr) {
		// Set slice() to avoid to generate an infinite loop!
			let arrServices = arr;
			// console.log(arrServices);
			return arrServices.slice().sort((a, b)=>{
				// console.log(a.InsertTime);
				// return b.InsertTime - a.InsertTime;
				let ar=this.isArchive(a) - this.isArchive(b)
				if(ar == 0){
					// Сортируем по созданию
					return b.id - a.id;
				}else{
					// Выводим эту сортировку
					return ar;
				}
			});


		},
		showServices(event){
			this.ishidden = !this.ishidden;
			// console.log(numOfServicesNotInWork);
			if (this.ishidden) {
				this.expandText.text = "Показать услуги в архиве";
				// this.expandText.text = "Показать все услуги: +";
			} else {
				this.expandText.text = "Скрыть услуги в архиве";
				// this.expandText.text = "Скрыть услуги: +";
			}
			
		},
		getServicesInWork(){
			this.ServicesInWork = this.masClient[0].SERVICES.filter(s=>!this.isArchive(s));
			this.ServicesInWorkSelect = [];
			this.ServicesInArchive = [];
			let service = this.$route.query.service;
			this.ServicesInWorkSelect = this.masClient[0].SERVICES_LIST.map(r=>((r.id=String(r.id)),r));
			for(let i=0; i < this.masClient[0].SERVICES.length; i++){

				if(this.isArchive(this.masClient[0].SERVICES[i]) == 0){
					// this.ServicesInWork.push(this.masClient[0].SERVICES[i]);
					// this.ServicesInWorkSelect.push({id: String(this.masClient[0].SERVICES[i].id), BP_NAME: this.masClient[0].SERVICES[i].BP_NAME + ' ' + this.masClient[0].SERVICES[i].BP_EXT_NAME});
					// this.ServicesInWork.push(this.masClient[0].SERVICES[i]); 
				
					if(this.masClient[0].SERVICES[i].id == service && this.strChosenService != String(service)){
						this.strChosenService = String(service);
						this.getClient(service);
					}
				} else {
					this.ServicesInArchive.push(this.masClient[0].SERVICES[i]);
				}
			}
		},
		GoToEdit(bGoEdit=true){
			//this.bIsEdit = bGo;
			if(bGoEdit){
				this.$router.push({path: '/data/clients/id/'+this.$route.params.client_id+'/edit?client_type='+this.masClient[0].client_type});
			}else{
				if(location.pathname.indexOf('/data/clients/add') != -1){
					this.$router.push({path: '/data/clients'});
				}else{
					this.$router.push({path: '/data/clients/id/'+this.$route.params.client_id});
				}
			}
		},
		GoToHistory(){
			this.$router.push({path: '/data/clients/id/'+this.$route.params.client_id+'/history'});
		},
		GoToChat(){
			this.$router.push({path: '/data/clients/id/'+this.$route.params.client_id+'/chat'});
		},
		onCollapseClient(opt){
			this.objTabs.client = opt;
			this.saveTabs();
		},
		onCollapseMain(opt){
			this.objTabs.main = opt;
			this.saveTabs();
		},
		onCollapseTask(opt){
			this.objTabs.task = opt;
			this.saveTabs();
		},
		onCollapseLenta(opt){
			this.objTabs.lenta = opt;
			this.saveTabs();
		},
		saveTabs() {
			const parsed = JSON.stringify(this.objTabs);
			localStorage.setItem('objTabs', parsed);
		},

		GetNoPurposeOptions(){
			// if(this.objService.editable==1 && this.objService.STATUS!='На контроле' && this.objService.STATUS!='Сделка закрыта'){}
				// this.$GVO.ApiCall('GET_NOPURPOSE_SEL_FIELDS',{obj:'BP',flt:{'bp_id':this.objService.BP_ID}})
				this.$GVO.ApiCall('GET_NOPURPOSE_SEL_FIELDS',{obj:'BP',flt:{'bp_id':'all'}})
					.then((objApi) => {
						if(objApi.success === true){
							// this.objNoPurpose.options = objApi.data.options;
							this.objNoPurpose.group_bp_id = objApi.data.group_bp_id;
							
							// if(objApi.data.default_sel != -1 && objApi.data.default_sel != ''){
							// 	this.objNoPurpose.selectedVal = objApi.data.default_sel;
							// 	this.onCh(this.objNoPurpose.selectedVal);
							// }
						}
					}).catch(errorObjApi => console.error(errorObjApi));
			
		},

		// getServicesForTaskFilter(strChosenService){
		// 	for(let i=0; i < this.masClient[0].SERVICES.length; i++){
		// 		if(strChosenService == this.masClient[0].SERVICES[i].id ){
		// 			this.strChosenServiceID = this.masClient[0].SERVICES[i].id;
					
		// 		}
		// 	}
		// 	if(strChosenService == ''){this.strChosenServiceID =''}
		// 	//console.log(this.strChosenServiceID);
		// },
		receiveEmitAnchor(service_id){
			this.anchorServiceID = service_id;
			// console.log('You clicked this.anchorServiceID: ' + this.strChosenService);
		},
		filterClientDataByService(strChosenService){
			// console.log(strChosenService);
		},
		reload_tasks(){
			// console.log('client reload');
			this.getClient(this.strChosenService)
		},
		init(){
			if (localStorage.getItem('objTabs')) {
				try {
					this.objTabs = JSON.parse(localStorage.getItem('objTabs'));
					if(this.$GVO.isEmpty(this.objTabs)){
						this.objTabs = {client:true,main:true,task:true,lenta:true};
					}
				} catch(e) {
					localStorage.removeItem('objTabs');
				}
			}
			if(location.pathname.indexOf('/data/clients/add') != -1){
					this.bIsEdit = true;
			}else{
				if(location.pathname.indexOf('/edit') != -1){
					this.bIsEdit = true;
				}else{
					this.bIsEdit = false;
				}
			}
			if(this.objNoPurpose.options.length == 0) {this.GetNoPurposeOptions();}

			
			this.getServiceFilter();
			this.getClient();
		},
	},
	mounted() {
		// this.getNumberOfTasks();
		
	},
	computed: {
		isAdmin(){
			return (this.$GVO.my_profile.adm == 1)
		},
	},
	created(){
		eventEmitter.$on('reload_tasks', this.reload_tasks);
		this.init();
		
	},
	beforeDestroy() {
		// Отписываемся от события
		eventEmitter.$off('reload_tasks', this.reload_tasks);
	},
};
</script>
<style>
	.clientPage.bntGroup{
		position: absolute;
		z-index: 1;
		right: 35px;
	}
	.clientPage.bntGroup .btn-history{
		position: absolute;
		right: 0px;
		bottom: -50px;
	}
	.clientPage.bntGroup .btn-chat{
		position: absolute;
		right: 0px;
		bottom: -100px;
	}
	
	/*.clientPage .my-row .collapseArrow  {
		height: fit-content;
		display: inline-block;
		width: 49%;
		padding: 0px;
	}
	*/
	/*.clientPage .my-row .card-collapse,*/ .clientPage .my-row > div {
		border-right: medium solid #01b0e0;
		/* border-right: 1px solid #01b0e0; */
		height: fit-content;
		display: inline-block;
		/* width: 49%; */
		width: 50%;
		padding: 0px;
	}
	.card-collapse > .card > .card-header{
		border-bottom: 2px solid #01B0E0;
	}
	.my-row .card-collapse[name^="c-"] > .card > .card-header a[data-toggle="collapse"] i {bottom: -7px; float:none; display: none;}
	/* .collapseArrow .card-collapse[name^="c-"] > .card > .card-header a[data-toggle="collapse"] i {bottom: -7px; float:none; display: none;} */
	/* .my-row .card-collapse[name^="c-"] > .card:not(.card-cinc) .card-body {padding-left: 0px; padding-right: 0px;} */
	.clientPage .card-collapse[name^="c-"] > .card > .card-header{
		/* border-bottom: 2px solid #01B0E0; */
		/* border-bottom: thick double #01B0E0; */
		/*border-bottom: thick solid #01B0E0;*/ /*если тень с размытием или только внизу, то лучше thin или medium*/
		/*box-shadow: 7px 7px rgb(158 119 243 / 40%);*/ /*тень без размытия */
		border-bottom: medium solid #01B0E0;
		box-shadow: 0 9px 7px -3px rgb(158 119 243 / 40%);
		background-color: #01b0e01b!important; 
		margin-bottom: 10px;
	}
	.clientPage .card-collapse[name^="c-ct_"] > .card > .card-header {border-bottom: medium solid #01B0E0; box-shadow: 0 7px 7px 0 rgb(158 119 243 / 40%);}
	/* .clientPage .my-row{
		padding: 0px 20px;
	} */
	.clientPage .my-row > div:nth-child(2){
		border-right: 0px;
		float: right;
	}
	.col-title{
		display: inline-flex;
		width: 100%;
		/* width: calc(100% - 20px); */
		align-items: baseline;
	}
	.col-title > *{
		display: inline-block;
		margin-bottom: 0px;
	}
	.postAddForm-hide {
		display: none;
	}
	.postAddForm-show {
		display: block;
		margin-top: 15px;
	}
	.postForm {
		border: 1px solid transparent;
		border: 1px solid #01B0E0;
		border-radius: 0.2857rem;
		position: sticky;
		bottom: 0;
	}
	.clientPage .card-collapse .postForm {
		background: #27293d;
	}
	.white-content .card:not(.card-white) .postForm {
		background: #fff;
	}
	.postForm:hover, .focus-shadow  {
		box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
	}
	.postForm h5 {
		cursor: pointer; 
		margin-bottom: 0px;
	}
	.form-container {display: flex; flex-direction: column; justify-content: space-between;}
	.postForm .bottom_part, .top_part  {display: flex; flex-wrap: wrap;}
	.postForm .bottom_part button, .fileinput {margin: 10px 10px 0px 0px;}
	.task-pl-3 {padding-left: 16px;}
	.clientPage .card-collapse .card:not(.card-cinc) .card-header {
		padding: 0.75rem 0.75rem 0 0.75rem;
	}
	.tasksFiltering {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.hideServices {
		display: none;
		/*background: rgba(1, 176, 224, 0.3);*/
	}
	.anchorService{
		box-shadow: 0px 1px 20px 0px rgba(158, 119, 243, 0.9)!important;
	}
	.title-client-fio {word-break:break-all;}
	

	/*.white-content .card:not(.card-white) .lightTheme {border: 1px solid #c4c4c4;}*/

	.ServiceFilter {
		border: 1px solid #9e77f3;
	}
	.white-content .card:not(.card-white) .clientPage .lightTheme {background: #f1f6fc!important; box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important; border: 1px solid #9e77f3;}
	.ServiceFilter .select-primary.el-select .el-input input {height: 40px!important;}

	@media (max-width: 768px){
		/* .clientPage .my-row .card-collapse, .clientPage .my-row .collapseArrow{ */
		.clientPage .my-row .card-collapse, .clientPage .my-row {
			border-right: 0px;
			display: block;
			width: 100%;			
		}
		.clientPage .my-row > div:nth-child(2){
			float: none;
		}
		.mobilePadding > .card-body {padding: 15px 0;}
		.clientPage >>> .card-collapse .card-body {padding: 5px 0;}
		.task-pl-3 {padding-left: 0px;} 
		.clientPage .card-collapse[name^="c-"] > .card > .card-header {
			margin-bottom: 0px;
		}
	}

	@media (max-width: 520px){
		.clientPage .my-row{
			padding: 0px 5px;
		}
	}
</style>
